import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FaPlus, FaSave } from 'react-icons/fa'
import {
    Button,
    ButtonGroup,
    CircularProgress,
    IconButton,
    InputAdornment,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { TiCancel } from 'react-icons/ti';
import { HiOutlineSearch } from 'react-icons/hi';
import ClickOutsideWrapper from '../../pages/ClickOutsideWrapper';
import Div from '@jumbo/shared/Div';
import { BiEdit, BiSolidFilePdf } from 'react-icons/bi';
import { MdCalendarToday, MdClose, MdDelete } from 'react-icons/md';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { format } from 'date-fns';
import RefreshImage from './../../../assets/images/circular.png';
import ApplyImage from './../../../assets/images/apply.png';
import PropTypes from 'prop-types';


export const ErpCreateButton = ({ handleClick, name, icon, disableButton = false, loading = false, ...props }) => {
    return (
        <ButtonGroup
            aria-label="split button"
            // onClick={handleClick}
            // {...props}
            sx={{ width: { xs: "100% !important", lg: "100% !important", xl: "100% !important" }, display: "flex", justifyContent: "end", textAlign: "right" }}
        >
            <Button
                className="create-button"
                variant="contained"
                onClick={handleClick}
                startIcon={icon || <FaPlus size={15} />}
                {...props}
                disabled={disableButton}
            >
                {loading ? <CircularProgress size={20} color="inherit" /> : (name)}
            </Button>
        </ButtonGroup>
    )
}


export const ErpSaveUpdateButton = ({ name, type, className = 'plus-button', icon = <FaSave size={16} />, width = "fit-content", onClick, loading = false, disabled = false }) => {
    return (
        <ButtonGroup
            aria-label="split button"
            // type={type}
            // onClick={onClick}
            // disabled={loading || disabled}
            sx={{
                mr: { xs: 1, md: 1 },
                "&:hover": {
                    // backgroundColor: alpha(bgColor, 0.8),
                    boxShadow: "none",
                },
            }}
        >
            <Button
                type={type}
                className={className}
                variant="contained"
                onClick={onClick}
                startIcon={icon}
                disabled={loading || disabled}
                sx={{ width: width }}
            >
                {loading ? <CircularProgress size={20} color="inherit" /> : (name)}
            </Button>
        </ButtonGroup>
    )
}


export const ErpCancelButton = ({ onClick, name = "Cancel", icon = <TiCancel size={22} />, ...props }) => {
    return (
        <ButtonGroup
            aria-label="split button"
            onClick={onClick}
            sx={{
                mr: { xs: 0, md: 1 },
                backgroundColor: "#ECECEC",
                color: "#017890 !important",
            }}
        >
            <Button className="plus-button" variant="primary" startIcon={icon} {...props}>{name}</Button>
        </ButtonGroup>
    )
}


export const FoyerCloseButton = ({ onClick }) => {
    return (
        <ButtonGroup
            aria-label="split button"
            onClick={onClick}
            sx={{
                mt: { xs: 0.5, lg: 0 },
                mr: { xs: 0, md: 1 },
                backgroundColor: "#ECECEC",
                color: "#017890 !important"
            }}
        >
            <Button className="plus-button" variant="primary" startIcon={<MdClose size={20} />}>Close</Button>
        </ButtonGroup>
    )
}


export const ErpSearchBox = ({ handleChange, searchData = "" }) => {
    return (
        <TextField
            className="col-12 input-box"
            id="outlined-search"
            type="search"
            value={searchData || null}
            onChange={handleChange}
            placeholder="Search..."
            autoComplete="off"
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <HiOutlineSearch size={20} />
                    </InputAdornment>
                ),
            }}
        />
    )
}


export const ErpFilterBox = ({ handleClickOutside, showFilter, handleFilter, RefreshData, loading, children }) => {
    return (
        <ClickOutsideWrapper onClickOutside={handleClickOutside}>
            <form onSubmit={handleFilter}>
                <Div
                    className="card filter-box mt-2"
                    id="openFilter"
                    sx={{
                        maxWidth: { xs: "600px !important", md: "550px !important" },
                        margin: { xs: "10px 20px 0px -20px !important", md: "0px !important" },
                        display: showFilter === true ? `block` : `none`,
                    }}
                >
                    <Div
                        sx={{
                            p: 1.4,
                            pb: 0,
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Typography variant="h3">Filters</Typography>
                        <IconButton
                            onClick={RefreshData}
                            color="primary"
                            sx={{ mt: -1.5, mr: -0.8 }}
                        >
                            <img
                                src={RefreshImage}
                                alt="Refresh"
                                width={18}
                                height={18}
                            />
                        </IconButton>
                    </Div>
                    <Div
                        sx={{
                            p: 1.5,
                            pt: 0,
                            maxHeight: "350px",
                            overflowY: "scroll",
                            "&::-webkit-scrollbar": {
                                width: "8px",
                                height: '8px',
                                transition: "opacity 0.5s ease",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                background: "#b1b1b1ff",
                                borderRadius: "50px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                background: "#939393ff",
                            },
                        }}
                    >
                        {children}
                    </Div>
                    <Div
                        sx={{
                            mt: 2,
                            mb: 2,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <ErpSaveUpdateButton
                            type="submit"
                            name={"Apply"}
                            icon={
                                <img
                                    src={ApplyImage}
                                    alt="apply"
                                    width={20}
                                    height={20}
                                />
                            }
                            loading={loading}
                        />
                    </Div>
                </Div>
            </form>
        </ClickOutsideWrapper>
    )
}


export const ErpActionButton = ({ userRolePermissions, editPermissionId, deletePermissionId, onClickEdit, onClickDelete, align = "center" }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Div sx={{ textAlign: isMobile ? "left" : align, pr: align === "right" ? 1 : 0 }}>
            {editPermissionId &&
                <Tooltip title="Edit">
                    <IconButton
                        size="small"
                        className="edit-icon"
                        onClick={onClickEdit}
                        disabled={!Array.isArray(userRolePermissions) || !(userRolePermissions.includes(editPermissionId))}
                    >
                        <BiEdit
                            color={Array.isArray(userRolePermissions) && (userRolePermissions || [])?.includes(editPermissionId) ? "" : "#C7C8CC"}
                        />
                    </IconButton>
                </Tooltip>
            }

            {deletePermissionId &&
                <Tooltip title="Delete">
                    <IconButton
                        size="small"
                        className="delete-icon"
                        onClick={onClickDelete}
                        disabled={!Array.isArray(userRolePermissions) || !(userRolePermissions.includes(deletePermissionId))}
                    >
                        <MdDelete
                            color={Array.isArray(userRolePermissions) && (userRolePermissions || [])?.includes(deletePermissionId) ? "" : "#C7C8CC"}
                        />
                    </IconButton>
                </Tooltip>
            }
        </Div>
    )
}


export const ErpPDFExcelDownloadButton = ({
    handleDownloadPDF,
    handleDownloadExcel,
    conditions = false,
    stopAnimation = true }) => {
    return (
        <Div sx={{ display: "flex", justifyContent: "flex-end", alignItems: "end", gap: 1 }}>
            <Button
                className={(!Boolean(conditions) && Boolean(stopAnimation)) ? "PDF-Excel-Button" : ""}
                sx={{
                    minWidth: "110px !important",
                    height: "34px !important",
                    "&:hover": {
                        bgcolor: "#017890 !important",
                        color: "white !important",
                    },
                }}
                variant={(Boolean(conditions) && Boolean(stopAnimation)) ? "contained" : "outlined"}
                startIcon={<BiSolidFilePdf size={22} />}
                onClick={() => handleDownloadPDF()}
                disabled={conditions}
            >
                PDF
            </Button>

            <Button
                className={(!Boolean(conditions) && Boolean(stopAnimation)) ? "PDF-Excel-Button" : ""}
                sx={{
                    minWidth: "110px !important",
                    height: "34px !important",
                    "&:hover": {
                        bgcolor: "#3FD3A4 !important",
                        color: "white !important",
                    },
                }}
                variant={(Boolean(conditions) && Boolean(stopAnimation)) ? "contained" : "outlined"}
                color="success"
                startIcon={<RiFileExcel2Fill size={20} />}
                onClick={() => handleDownloadExcel()}
                disabled={conditions}
            >
                Excel
            </Button>
        </Div>
    )
}


export const ErpDateField = ({ value, onChange, InputProps: parentInputProps, fullWidth = true, ...props }) => {
    const [showDateField, setShowDateField] = useState(false);
    const [dateFormat, setDateFormat] = useState(localStorage.getItem("DateFormat"));
    const dateFieldRef = useRef(null);
    const handleBlurDateField = useCallback((event) => {
        if (dateFieldRef.current && !dateFieldRef.current.contains(event.target)) {
            setShowDateField(false);
        }
    }, []);
    useEffect(() => {
        document.addEventListener("click", handleBlurDateField, true);
        return () => {
            document.removeEventListener("click", handleBlurDateField, true);
        };
    }, [handleBlurDateField]);

    useEffect(() => {
        const storedDateFormat = localStorage.getItem("DateFormat");
        if (storedDateFormat) {
            setDateFormat(storedDateFormat);
        }
    }, []);
    const formatDate = (date, formatString) => {
        try {
            return format(new Date(date), formatString);
        } catch (error) {
            console.error('Date formatting error:', error);
            return date;
        }
    };

    const formattedValue = !showDateField && value ? formatDate(value, dateFormat) : value;

    // Merge default InputProps with those from the parent
    const mergedInputProps = {
        ...parentInputProps,
        inputProps: {
            ...(parentInputProps?.inputProps || {}),
            ...(props?.inputProps || {}),
            min: parentInputProps?.inputProps?.min || props?.inputProps?.min,
            max: parentInputProps?.inputProps?.max || props?.inputProps?.max,
        },
        endAdornment: !showDateField && (
            <InputAdornment position="end">
                <IconButton
                    aria-label="toggle calendar"
                    onMouseEnter={() => setShowDateField(true)}
                    edge="end"
                    sx={{ pl: 0, pr: 1.28, mt: -0.2 }}
                >
                    <MdCalendarToday size={13.3} color={Boolean(props?.disabled) ? "gray" : '#000'} />
                </IconButton>
            </InputAdornment>
        ),
    };

    return (
        <TextField
            {...props}
            type={showDateField ? 'date' : 'text'}
            className={props?.className ? props?.className?.replaceAll("search-select", "input-box") : `col-12 input-box`}
            onFocus={() => setShowDateField(true)}
            value={formattedValue || ''}
            onChange={(e) => {
                onChange(e);
            }}
            ref={dateFieldRef}
            placeholder={localStorage.getItem("DateFormat")?.toLocaleLowerCase()?.replaceAll("-", "/")}
            InputProps={mergedInputProps}
            sx={{
                // width: "100%",
                '& input::placeholder': {
                    color: Boolean(props?.disabled) ? "gray" : '#000', // Adjust the color as needed
                    opacity: Boolean(props?.disabled) ? 0.5 : 0.8, /// Adjust the color as needed
                    marginTop: "3px"
                },
                '&:focus-within .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#017890', // Adjust the border color as needed
                },
                minWidth: props.minWidth ? props.minWidth : "140px !important",
                maxWidth: !fullWidth ? "140px !important" : "100%"
            }}
        />
    );
};

ErpCreateButton.propTypes = {
    handleClick: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    icon: PropTypes.element,
    type: PropTypes.string,
    disableButton: PropTypes.bool, // Add validation for loading prop
};

ErpSaveUpdateButton.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.element,
    width: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool, // Add validation for loading prop
};

ErpCancelButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    icon: PropTypes.element,
};

FoyerCloseButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

ErpSearchBox.propTypes = {
    handleChange: PropTypes.func.isRequired,
    searchData: PropTypes.string.isRequired,
};

ErpFilterBox.propTypes = {
    handleClickOutside: PropTypes.func.isRequired,
    showFilter: PropTypes.bool.isRequired,
    handleFilter: PropTypes.func.isRequired,
    RefreshData: PropTypes.func.isRequired,
    children: PropTypes.string.isRequired,
};

ErpActionButton.propTypes = {
    userRolePermissions: PropTypes.number,
    editPermissionId: PropTypes.number,
    deletePermissionId: PropTypes.number,
    onClickEdit: PropTypes.func.isRequired,
    onClickDelete: PropTypes.func.isRequired,
    align: PropTypes.string.isRequired,
};

ErpPDFExcelDownloadButton.propTypes = {
    handleDownloadPDF: PropTypes.func.isRequired,
    handleDownloadExcel: PropTypes.func.isRequired,
    conditions: PropTypes.string.isRequired,
    stopAnimation: PropTypes.string.isRequired,
};

ErpDateField.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    InputProps: PropTypes.object,
    handleDownloadExcel: PropTypes.func.isRequired,
    conditions: PropTypes.bool.isRequired,
    stopAnimation: PropTypes.bool.isRequired,
    parentInputProps: PropTypes.shape({
        inputProps: PropTypes.shape({
            min: PropTypes.number,
            max: PropTypes.number,
        }),
    }),
};
